module.exports = __webpack_public_path__ + "img/logo.a411bbb2.png";